<template>
    <div id="nav" :class="{'navbar-bg-scrolled' : !state.atTopOfPage, 'navbar-bg-not-scrolled': state.atTopOfPage}">
        <div class="container max-w-7xl mx-auto">
            <div class="block sm:hidden p-5">
                <logo class="mx-auto block sm:hidden"/>
                <button @click="toggle"
                        class="flex items-center px-3 py-2 border rounded text-teal-lighter border-teal-light">
                    <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <title>Menu</title>
                        <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
                    </svg>
                </button>
            </div>
            <div :class="state.open ? 'block': 'hidden'"
                 class="w-full flex-grow sm:flex sm:items-center sm:w-auto gap-2">
                <div class="nav-item" :class="{ 'nav-item-active': $page.component === 'Home' }">
                    <Link preserve-scroll :href="route('home')">{{ $t("Home") }}</Link>
                </div>
                <div class="nav-item" :class="{ 'nav-item-active': $page.component === 'Register' }">
                    <Link preserve-scroll :href="route('register')">{{ $t("Registration") }}</Link>
                </div>
                <div class="nav-item" :class="{ 'nav-item-active': $page.component === 'Download' }">
                    <Link preserve-scroll :href="route('download')">{{ $t("Download") }}</Link>
                </div>
                <div @click="isOpen" class="nav-item relative"
                     :class="{ 'nav-item-active': ['RankPlayer', 'RankGuild'].includes($page.component) }">
                    <span>{{ $t("Ranking") }}</span>
                    <div v-show="show"
                         class="font-bold text-base absolute mx-auto py-2 mt-2 bg-red-900 border border-yellow-200 outline outline-amber-800 w-44">
                        <div class="dropdown-item">
                            <Link preserve-scroll :href="route('rank.player')"><i class="fa-solid fa-user"></i>
                                {{ $t('Players') }}
                            </Link>
                        </div>
                        <div class="dropdown-item">
                            <Link preserve-scroll :href="route('rank.guild')"><i class="fa-solid fa-users"></i>
                                {{ $t('Guilds') }}
                            </Link>
                        </div>
                        <div v-if="config.vote4coins_v4c_ranking" class="dropdown-item">
                            <Link preserve-scroll :href="route('rank.vote')"><i class="fa-solid fa-users"></i>
                                {{ $t('Votes') }}
                            </Link>
                        </div>
                    </div>
                </div>
                <div class="nav-item" v-for="link in links">
                    <a :href="link.link">{{ link.name }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {Link, usePage} from '@inertiajs/inertia-vue3'
import {ref, computed, reactive, onBeforeMount} from 'vue';

const config = computed(() => usePage().props.value.config)

const state = reactive({
    atTopOfPage: true,
    pageOffset: 0,
    open: false
})

onBeforeMount(() => {
    window.addEventListener('scroll', handleScroll);
})

function handleScroll() {
    state.atTopOfPage = document.documentElement.scrollTop <= 0;
}

function toggle() {
    state.open = !state.open
}

let show = ref(false);
const isOpen = () => (show.value = !show.value)
let links = computed(() => usePage().props.value.nav.main)
</script>
